(function () {

    "use strict";

    // Routing
    function routingConfiguration($stateProvider) {

        $stateProvider
            .state("/", {
                url: "/",
                template: "<sphforms-home></sphforms-home>"
            });
    }

    routingConfiguration.$inject = ["$stateProvider"];

    angular.module("sphforms.main")
        .config(routingConfiguration);

    function themeConfiguration($mdThemingProvider) {
        $mdThemingProvider.definePalette('primaryPaletteSolpheo', {
            '50': 'fffafa', //'fff3e0',
            '100': 'ffe0b2',
            '200': 'ffcc80',
            '300': 'ffb74d',
            '400': 'ffa726',
            '500': 'f38b00', //'ff9800',
            '600': 'fb8c00',
            '700': 'f57c00',
            '800': 'ef6c00',
            '900': 'e65100',
            'A100': 'ffd180',
            'A200': 'ffab40',
            'A400': 'ff9100',
            'A700': 'ff6d00',
            'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
            // on this palette should be dark or light

            'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                '200', '300', '400', 'A100'],
            'contrastLightColors': undefined    // could also specify this if default was 'dark'
        });

        $mdThemingProvider.definePalette('secondaryPaletteSolpheo', {
            '50': 'fafafa',
            '100': 'f5f5f5',
            '200': 'eeeeee',
            '300': 'cccccc', //'e0e0e0',
            '400': 'bdbdbd',
            '500': '999999', //'9e9e9e',
            '600': '757575',
            '700': '666666', //'616161',
            '800': '424242',
            '900': '333333', //'212121',
            'A100': 'f5f5f5',
            'A200': 'eeeeee',
            'A400': 'bdbdbd',
            'A700': '616161',
            'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
            // on this palette should be dark or light

            'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                '200', '300', '400', 'A100'],
            'contrastLightColors': undefined    // could also specify this if default was 'dark'
        });


        $mdThemingProvider.theme('default')
            .primaryPalette('primaryPaletteSolpheo')
            .accentPalette('primaryPaletteSolpheo');

    }

    themeConfiguration.$inject = ["$mdThemingProvider"];
    angular.module("sphforms.main")
        .config(themeConfiguration);

}());







